function enhancePasswordFields() {
  document.querySelectorAll('input[type="password"]').forEach((input) => {
    if (input.dataset.passwordVisibilityEnhanced === 'true') return

    input.dataset.passwordVisibilityEnhanced = 'true'
    const hadFormControl = input.classList.contains('form-control')
    const originalWidth = input.getBoundingClientRect().width
    input.style.backgroundImage = 'none'

    const wrapper = document.createElement('div')
    wrapper.className = 'password-field-wrapper position-relative'

    const movedWidthClass = moveWidthClasses(input, wrapper)
    if (!movedWidthClass && !hadFormControl && originalWidth > 0) {
      wrapper.style.width = `${originalWidth}px`
    }

    if (hadFormControl || movedWidthClass) {
      input.classList.add('form-control')
      input.classList.add('pr-5')
    } else {
      input.style.boxSizing = 'border-box'
      input.style.paddingRight = '2.75rem'
      input.style.width = '100%'
    }

    input.parentNode.insertBefore(wrapper, input)
    wrapper.appendChild(input)

    const button = document.createElement('button')
    button.type = 'button'
    button.className = 'btn btn-link password-visibility-toggle p-0'
    button.innerHTML = eyeIcon()
    button.setAttribute('aria-label', 'Show password')
    Object.assign(button.style, {
      color: '#0d6efd',
      height: '2rem',
      lineHeight: '1',
      position: 'absolute',
      right: '0.5rem',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '2rem',
      zIndex: '3'
    })
    button.addEventListener('click', () => togglePasswordVisibility(input, button))

    wrapper.appendChild(button)
  })
}

function moveWidthClasses(input, wrapper) {
  let movedWidthClass = false

  Array.from(input.classList).forEach((className) => {
    if (className.match(/^col(-|$)/) || className.match(/^w-\d+/)) {
      movedWidthClass = true
      wrapper.classList.add(className)
      input.classList.remove(className)

      if (className.match(/^col(-|$)/)) {
        wrapper.style.paddingLeft = '0'
        wrapper.style.paddingRight = '0'
      }
    }
  })

  return movedWidthClass
}

function togglePasswordVisibility(input, button) {
  const showingPassword = input.type === 'text'

  input.type = showingPassword ? 'password' : 'text'
  button.innerHTML = showingPassword ? eyeIcon() : eyeOffIcon()
  button.setAttribute('aria-label', showingPassword ? 'Show password' : 'Hide password')
}

function eyeIcon() {
  return `
    <svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </svg>
  `
}

function eyeOffIcon() {
  return `
    <svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M17.94 17.94A10.9 10.9 0 0 1 12 19c-6.5 0-10-7-10-7a18.4 18.4 0 0 1 5.06-5.94"></path>
      <path d="M9.9 4.24A10.8 10.8 0 0 1 12 5c6.5 0 10 7 10 7a18.5 18.5 0 0 1-2.16 3.19"></path>
      <path d="M14.12 14.12A3 3 0 0 1 9.88 9.88"></path>
      <path d="M1 1l22 22"></path>
    </svg>
  `
}

function validatePasswordConfirmations() {
  document.querySelectorAll('form').forEach((form) => {
    const password = form.querySelector(passwordSelector())
    const confirmation = form.querySelector(passwordConfirmationSelector())

    if (!password || !confirmation || confirmation.dataset.passwordConfirmationEnhanced === 'true') return

    confirmation.dataset.passwordConfirmationEnhanced = 'true'

    const validate = () => {
      const mismatched = password.value.length > 0 &&
        confirmation.value.length > 0 &&
        password.value !== confirmation.value

      confirmation.setCustomValidity(mismatched ? 'Passwords do not match.' : '')
      confirmation.classList.toggle('is-invalid', mismatched)
      setConfirmationFeedback(confirmation, mismatched)
    }

    password.addEventListener('input', validate)
    confirmation.addEventListener('input', validate)
    form.addEventListener('submit', (event) => {
      validate()

      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
        form.reportValidity()
      }
    })
  })
}

function passwordSelector() {
  return [
    'input[name$="[password]"]',
    'input[name="password"]',
    'input#password',
    'input[id$="_password"]:not([id$="_password_confirmation"])'
  ].join(', ')
}

function passwordConfirmationSelector() {
  return [
    'input[name$="[password_confirmation]"]',
    'input[name="password_confirmation"]',
    'input#password_confirmation',
    'input[id$="_password_confirmation"]'
  ].join(', ')
}

function setConfirmationFeedback(input, visible) {
  const feedback = findOrCreateFeedback(input)
  feedback.textContent = 'Passwords do not match.'
  feedback.classList.toggle('d-block', visible)
}

function findOrCreateFeedback(input) {
  const container = input.closest('.password-field-wrapper') || input
  let feedback = container.querySelector('.password-confirmation-feedback')

  if (!feedback) {
    feedback = document.createElement('div')
    feedback.className = 'invalid-feedback password-confirmation-feedback'
    container.appendChild(feedback)
  }

  return feedback
}

document.addEventListener('turbolinks:load', () => {
  enhancePasswordFields()
  validatePasswordConfirmations()
})
